<template>
    <base-draggable-modal
        name="create_fieldset"
        max-height="80vh"
        width="50vw"
        :fullscreen="$vuetify.display.xsOnly"
        ref="create_fieldset">
      <v-card rounded="xl">
        <base-modal>
          <template #header>
            <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
              <v-toolbar-title class="text-primary">{{ $store.getters.translate('create') }} {{ $store.getters.translate('fieldset') }}</v-toolbar-title>
            </v-toolbar>
          </template>
          <template #content>
              <v-card-text>
                <v-text-field
                    density="default"
                    class="reg-normal text-primary"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    v-model="new_fieldset_name"
                    hide-details
                    flat
                    clearable>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('name') }}</span>
                  </template>
                </v-text-field>
              </v-card-text>
          </template>
          <template #footer>
            <v-card-text>
              <v-row>
                <v-col>
                  <base-action-button :width="'100%'" @action="closeModal('create_fieldset')">
                    <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                    {{ $store.getters.translate("cancel") }}
                  </base-action-button>
                </v-col>
                <v-col>
                  <base-action-button :background="true" :width="'100%'" @action="save">
                    <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                    {{ $store.getters.translate("save") }}
                  </base-action-button>
                </v-col>
              </v-row>
            </v-card-text>
          </template>
        </base-modal>
      </v-card>
    </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhFloppyDisk, PhX,
  },
  data() {
    return {
      new_fieldset_name: null,
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.openModal('create_fieldset');
    },
    async save() {
      this.$emit('created', this.new_fieldset_name);
      this.closeModal('create_fieldset');
    },
  }
};
</script>